export const DELETE_COMMENT_MUTATION = `
  mutation DeleteCommentMutation($id: ID!) {
    me {
      deleteComment(id: $id)
    }
  }
`;
